module.exports = __webpack_public_path__ + "img/pie-chart.93a2fe80.svg";